
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class CustomerOnboardingSuccessView extends Vue {
  async created () {}

  async mounted () {}
}
